import gql from 'graphql-tag';

const getSpotlightArticlesQuery = (field) => (field === 'newsArticles'
  ? gql`
    query getSpotlightNewsArticles(
      $keywords: [String],
      $limit: Int,
      $offset: Int,
      $featured: Boolean,
      $notInIds: [Int]
      $sort: NewsArticleSorting
      $inDays: Int
      $inIds: [Int]
      $categoryIds: [Int]
      $inCreatedByIds: [Int],
      $newsboards: [Newsboard],
      $tagSlug: String!,
      $tagSlugs: [String],
      $statuses: [NewsArticleStatus]
      $imageConfigurations: [ResponsiveImageConfiguration]!,
    ) {
      tag(slug: $tagSlug) {
        slug
        newsArticles(
          keywords: $keywords,
          limit: $limit,
          offset: $offset,
          featured: $featured,
          notInIds: $notInIds
          sort: $sort
          inDays: $inDays
          inIds: $inIds
          categoryIds: $categoryIds,
          inCreatedByIds: $inCreatedByIds
          newsboards: $newsboards
          tagSlugs: $tagSlugs
          statuses: $statuses
        ) {
          id
          title
          description
          summary
          imageUrls(configurations: $imageConfigurations)
          creator {
            id
            name
          }
          createdAt
          slug
          category {
            id
            title
            path
          }
          labels
        }
      }
    }
  `
  : gql`
    query getSpotlightNewsArticles(
      $keywords: [String],
      $limit: Int,
      $offset: Int,
      $featured: Boolean,
      $notInIds: [Int]
      $sort: NewsArticleSorting
      $inDays: Int
      $inIds: [Int]
      $categoryIds: [Int]
      $inCreatedByIds: [Int],
      $tagSlug: String!,
      $tagSlugs: [String],
      $statuses: [NewsArticleStatus]
      $imageConfigurations: [ResponsiveImageConfiguration]!,
    ) {
      tag(slug: $tagSlug) {
        slug
        ${field}(
          keywords: $keywords,
          limit: $limit,
          offset: $offset,
          featured: $featured,
          notInIds: $notInIds
          sort: $sort
          inDays: $inDays
          inIds: $inIds
          categoryIds: $categoryIds
          inCreatedByIds: $inCreatedByIds
          tagSlugs: $tagSlugs
          statuses: $statuses
        ) {
          id
          title
          description
          summary
          imageUrls(configurations: $imageConfigurations)
          creator {
            id
            name
          }
          createdAt
          slug
          path
          category {
            id
            title
            path
          }
          labels
        }
      }
    }
  `
);

export default getSpotlightArticlesQuery;
